module.exports = __webpack_public_path__ + "img/humidity_icon.17b8785d.svg";